import React from 'react';
import { Link } from 'react-router-dom';

import { Item, Section } from './list';
import { cn } from './lib/utils';
import { PopoverContext } from './popover';

/* Port of `~co/overlay/popover/menu` — dropdown list inside a Popover.
   `.ui-menu`/`.ui-menu-item` styles unlayered in global.css. */

export const Menu = React.forwardRef(function Menu(
  { children, className, ...props },
  ref,
) {
  return (
    <div {...props} ref={ref} className={cn('ui-menu', className)}>
      {children}
    </div>
  );
});

export class MenuItem extends React.Component {
  static contextType = PopoverContext;

  onClick = (e) => {
    if ((this.props.href || this.props.to) == false) e.preventDefault();

    this.props.onClick && this.props.onClick(e);

    this.context.close();
  };

  render() {
    const { children, className, as = 'a', ...etc } = this.props;
    const Tag = etc.to ? Link : as;

    return (
      <Item
        as={Tag}
        tabIndex='0'
        {...etc}
        data-menu-item
        className={cn('ui-menu-item', className)}
        onClick={this.onClick}
      >
        {children}
      </Item>
    );
  }
}

export function MenuSeparator() {
  return <span className='ui-menu-separator' />;
}

export function MenuSection(props) {
  return <Section {...props} />;
}
